<script setup>
import { computed, inject } from 'vue'
import { useRouter } from 'vue-router'
import { useGlobalStore } from '@/store/global.js'
import { useAuthStore } from '@/store/auth.js'
import { callAuthModal } from '@/utils/global.js'

// The site header is now the shared <ns-header> web component (@nashsever/chrome).
// This wrapper feeds it the menu/user data and wires its events to the app's
// existing logic (auth modal, theme toggle, router) — one source of chrome
// across v1, v2 and the embedded front-ends.
const global = useGlobalStore()
const auth = useAuthStore()
const router = useRouter()
const theme = inject('theme')

// Mirrors the previous navigation: static Блог/Афиша, the menu dropdowns, and
// Сервисы sourced from the services list.
const navigation = computed(() => {
  const menu = global.resources?.menu ?? {}
  const services = (global.resources?.services ?? []).map(s => ({
    title: s.title,
    link: s.link,
    external: true,
  }))
  return [
    { title: 'Блог', link: '/blog' },
    { title: 'Афиша', link: '/afisha' },
    menu.activities,
    menu.projects,
    { title: 'Сервисы', children: services },
    menu.contests,
    menu.grants,
  ].filter(Boolean)
})

const navAttr = computed(() => JSON.stringify(navigation.value))
const userAttr = computed(() => (auth.user ? JSON.stringify({ name: auth.user.title }) : undefined))
const notifications = computed(() => auth.user?.notifications_count ?? 0)

/** Unwrap a custom-element CustomEvent payload (Vue wraps emit args in an array). */
function detail(e) {
  const d = e.detail
  return Array.isArray(d) ? d[0] : d
}

function onNavigate(e) {
  const p = detail(e)
  if (p?.link) {
    router.push(p.link)
  }
}
function onLogin() {
  callAuthModal()
}
function onProfile() {
  router.push('/profile/main')
}
function onLogout() {
  auth.logout()
}
function onNotifications() {
  router.push('/profile/messages')
}
function onTheme() {
  theme.value = theme.value === 'dark' ? 'light' : 'dark'
}
</script>

<template>
  <ns-header
    home="/"
    :nav="navAttr"
    :user="userAttr"
    :notifications="notifications"
    :theme="theme"
    @navigate="onNavigate"
    @login="onLogin"
    @profile="onProfile"
    @logout="onLogout"
    @notifications="onNotifications"
    @theme="onTheme"
  />
</template>
